export const loading = (state) => state.loading;
export const carouselImage = (state) => state.loading;
export const carouselLink = (state) => state.loading;
export const smallLoading = (state) => state.smallLoading;
